export const DocOperationFileType = {
  PDF: "10",
  DOC: "20",
  DOCX: "21",
  PPT: "30",
  PPTX: "31",
  TXT: "40",
  IMG: "50",
  XLSX: "60",
  XLS: "61",
  HTML: "70",
  URL: "71",
  HTM: "72",
  ODT: "80",
  RTF: "90",
  JPG: "100",
  JPEG: "101",
  PNG: "102",
  TIFF: "103",
  SVG: "104",
  TIF: "105",
  BMP: "106",
  MP4: "107",
  WAV: "108",
  AAC: "109",
  MP3: "110",
  AC3: "111",
  AIF: "112",
  AIFC: "113",
  AIFF: "114",
  AMR: "115",
  AU: "116",
  CAF: "117",
  FLAC: "118",
  M4A: "119",
  M4B: "120",
  OGA: "121",
  VOC: "122",
  WEBA: "123",
  WMA: "124",
  THREEFR: "130",
  ARW: "131",
  AVIF: "132",
  CR2: "134",
  CR3: "135",
  CRW: "136",
  DCR: "137",
  DNG: "138",
  EPS: "139",
  ERF: "140",
  GIF: "141",
  HEIC: "142",
  HEIF: "143",
  ICNS: "144",
  ICO: "145",
  JFIF: "146",
  MOS: "149",
  MRW: "150",
  NEF: "151",
  ODD: "152",
  ODG: "153",
  ORF: "154",
  PEF: "155",
  PPM: "157",
  PS: "158",
  PSD: "159",
  RAF: "160",
  RAW: "161",
  RW2: "162",
  WEBP: "165",
  X3F: "166",
  XCF: "167",
  XPS: "168",
  THREEG2: "170",
  THREEGP: "171",
  THREEGPP: "172",
  AVI: "173",
  CAVS: "174",
  DV: "175",
  DVR: "176",
  FLV: "177",
  M2TS: "178",
  M4V: "179",
  MKV: "180",
  MOD: "181",
  MOV: "182",
  MPEG: "184",
  MPG: "185",
  MTS: "186",
  MXF: "187",
  OGG: "188",
  RM: "189",
  RMVB: "190",
  SWF: "191",
  TS: "192",
  VOB: "193",
  WEBM: "194",
  WMV: "195",
  WTV: "196",
  DXF: "197",
  EMF: "198",
  WMF: "199",
  OPUS: "200",
  CDR: "201",
  DOT: "202",
  NONE: "500",
};
export const DocOperationType = {
  COMPRESS: "10",
  SPLIT: "20",
  MERGE: "30",
  CONVERT: "40",
  ANNOTATION: "50", //SENDING NONE FOR ANNOTATION FOR NOW
  REWRITE: "60",
  READ_PROTECTED_FILE: "70",
  SANITIZATION: "80",
  REPLACE_CONTAINER: "90",
  DOC_TRANSLATION: "100", //DOCUMENT TRANSLATION IN OTHER LANGUAGES
  TRANSCRIPTION: "120"
};
export const JobStatusEnum = {
  ENQUEUE: 10,
  INPROGRESS: 20,
  SUCCESS: 30,
  FAILED: 40,
};

export const EnvelopeStatus = {
  NONE: 0,
  DRAFT: 10,
  WAITFOROTHERS: 20,
  FINISHLATER: 30,
  RECALL: 40,
  VOID: 50,
  START: 60,
  INPROGESS: 70,
  SIGNED: 100,
};

export const SignerType = {
  SINGLESIGNER: 1,
  MULTISIGNER: 2,
};
